module.exports = __webpack_public_path__ + "img/marshall_islands.23117f1.webp";